import React from 'react';
import LoadingCell from '../../../../../ui/table/cells/loadingCell/loadingCell';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { useNavigate } from 'react-router-dom';

import './boardNameCell.scss';

const BoardNameCell = (props) => {
  let navigate = useNavigate();
  if (props.rowType === 'groupHeader') {
    return null;
  }

  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  const navigateToBoard = (investorId: number, boardId: number): void => {
    navigate(`/boards/${investorId}/${boardId}`);
  };

  return (
    <td className="document-cell" style={{ width: props.width }}>
      <Tooltip anchorElement="target">
        <div className="document-name-wrapper">
          {props.icon}
          <span title={props.dataItem[props.field]} onClick={() => navigateToBoard(props.dataItem.objectId, props.dataItem.contentId)}>{props.dataItem[props.field]}</span>
        </div>
      </Tooltip>
    </td>
  );
};

export default BoardNameCell;
